// Styles
import IframeContainer from "../IframeContainer.styles";
import PowerBIDashboard from "../../../components/Common/PowerBIDashboard";
import React from "react";

type Props = {};

export default function PublicCompanyDashboard({}: Props) {
    return (
        <IframeContainer>
            <div className="iframeContainer">
                <PowerBIDashboard
                    reportId="2005a5b3-942e-4893-bc18-879448c52ea2"
                    workspaceId="0ab7398c-fff1-4373-b543-e7d6d23657cd"
                ></PowerBIDashboard>
            </div>
        </IframeContainer>
    );
}
